// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Get, Post } from 'config/apiServiceConfig'

export const getHistoryCoin = (params: any): any =>
  Get({ url: '/api/loyalty/coin-transaction', params })
export const postInjectCoin = (body: any): any =>
  Post({ url: '/api/loyalty/inject/coin', data: body })
export const getTemplateBulkUploadCoin = (): any =>
  Get({ url: '/api/loyalty/inject/coin/csv/template' })
export const postBulkUploadHistoryCoin = (payload: any, config: any): any =>
  Post({ url: '/api/loyalty/inject/coin/bulk-upload', data: payload, config })
